"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _Filter = _interopRequireDefault(require("@react/react-spectrum/Icon/Filter"));

var _Icon = _interopRequireDefault(require("@react/react-spectrum/Icon"));

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _Popover = _interopRequireDefault(require("@react/react-spectrum/Popover"));

var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));

var _scrollIntoViewIfNeeded = _interopRequireDefault(require("scroll-into-view-if-needed"));

var _reactIntl = require("react-intl");

var _svgs = require("../../lib/svgs");

var _FilterPopover = _interopRequireDefault(require("./FilterPopover"));

var _Footer = _interopRequireDefault(require("./Footer.scss"));

var _useIngest = _interopRequireDefault(require("../../hooks/useIngest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var filterTooltipOverlayStyle = {
  pointerEvents: 'none'
};

var Filter = function Filter(_ref) {
  var commentsFilterClear = _ref.commentsFilterClear,
      commentsFilterTime = _ref.commentsFilterTime,
      commentsFilterUsers = _ref.commentsFilterUsers,
      disable = _ref.disable,
      filteredCommentsCount = _ref.filteredCommentsCount,
      isFilterOn = _ref.isFilterOn,
      filterTime = _ref.filterTime,
      filterUsers = _ref.filterUsers,
      showResolvedComments = _ref.showResolvedComments,
      toggleResolved = _ref.toggleResolved,
      touchControls = _ref.touchControls,
      users = _ref.users,
      visible = _ref.visible;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showFilterPopover = _useState2[0],
      setShowFilterPopover = _useState2[1];

  var firstFilterUserRef = (0, _react.useRef)();
  var ccxIngest = (0, _useIngest.default)();
  var intl = (0, _reactIntl.useIntl)();
  var formatMessage = intl.formatMessage;
  var filterButtonText = formatMessage({
    id: 'comments.arialabel.button.filter'
  });
  var filterStatusText = formatMessage({
    id: "comments.arialabel.status.".concat(isFilterOn ? 'filterApplied' : 'filterNotApplied')
  });
  var filterTooltip = formatMessage({
    id: 'comments.filter.tooltip'
  });
  var onFilterButtonClick = (0, _react.useCallback)(function (event) {
    // fixes https://jira.corp.adobe.com/browse/CCX-4994
    event.currentTarget.focus();
  }, []);
  var onOverlayHide = (0, _react.useCallback)(function () {
    setShowFilterPopover(false);
    ccxIngest.fireEvent(ccxIngest.events.filterHide);
  }, [ccxIngest]);
  var onOverlayShow = (0, _react.useCallback)(function () {
    setShowFilterPopover(true); // When filter is about to be shown, we schedule a scroll into the first selected user tag after the next render

    window.requestAnimationFrame(function () {
      if (filterUsers.length && firstFilterUserRef.current && firstFilterUserRef.current.buttonRef) {
        (0, _scrollIntoViewIfNeeded.default)(firstFilterUserRef.current.buttonRef, {
          block: 'nearest'
        });
      }
    });
    ccxIngest.fireEvent(ccxIngest.events.filterShow);
  }, [ccxIngest, filterUsers]);
  var onPopoverMouseDown = (0, _react.useCallback)(function (event) {
    // fixes https://jira.corp.adobe.com/browse/CCX-4869
    event.preventDefault();
  }, []);
  return visible ? /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    placement: "left",
    trigger: "hover"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    crossOffset: -1000,
    "data-testid": "filter-popover-overlay",
    onHide: onOverlayHide,
    onShow: onOverlayShow,
    placement: "top",
    trigger: "click"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-icon"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-expanded": showFilterPopover,
    "aria-label": "".concat(filterButtonText, " ").concat(filterStatusText),
    "data-testid": "ccx-comments-filter-button",
    disabled: disable,
    icon: isFilterOn ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
      size: "M"
    }, _svgs.filterBadgeIcon) : /*#__PURE__*/_react.default.createElement(_Filter.default, null),
    id: "ccx-filter-button",
    onPress: onFilterButtonClick,
    selected: isFilterOn,
    variant: "tool"
  })), /*#__PURE__*/_react.default.createElement(_Popover.default, {
    "aria-labelledby": "ccx-filter-button",
    className: _Footer.default.filter,
    onMouseDown: onPopoverMouseDown,
    open: true,
    placement: "top",
    title: null
  }, /*#__PURE__*/_react.default.createElement(_FilterPopover.default, {
    ref: firstFilterUserRef,
    ccxIngest: ccxIngest,
    commentsFilterClear: commentsFilterClear,
    commentsFilterTime: commentsFilterTime,
    commentsFilterUsers: commentsFilterUsers,
    filteredCommentsCount: filteredCommentsCount,
    filterTime: filterTime,
    filterUsers: filterUsers,
    intl: intl,
    showResolvedComments: showResolvedComments,
    toggleResolved: toggleResolved,
    touchControls: touchControls,
    users: users
  })))), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    style: filterTooltipOverlayStyle
  }, filterTooltip)) : null;
};

Filter.defaultProps = {
  disable: false,
  filterUsers: [],
  isFilterOn: false,
  touchControls: false,
  users: [],
  visible: false
};
Filter.propTypes = {
  commentsFilterClear: _propTypes.default.func.isRequired,
  commentsFilterTime: _propTypes.default.func.isRequired,
  commentsFilterUsers: _propTypes.default.func.isRequired,
  disable: _propTypes.default.bool,
  filteredCommentsCount: _propTypes.default.number.isRequired,
  filterTime: _propTypes.default.array.isRequired,
  filterUsers: _propTypes.default.array,
  isFilterOn: _propTypes.default.bool,
  showResolvedComments: _propTypes.default.bool.isRequired,
  toggleResolved: _propTypes.default.func.isRequired,
  touchControls: _propTypes.default.bool,
  users: _propTypes.default.array,
  visible: _propTypes.default.bool
};
var _default = Filter;
exports.default = _default;